import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { ROUTE_PATH } from "../constants/route-path";
import { AuthenticationService } from "../services/authentication.service";

@Injectable({ providedIn: 'root' })
export class DefaultRedirectGuard implements CanActivate {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService, 
  ) {}

  canActivate() {
    const office = this.authenticationService.getOfficeSelected();
    if (!office || !office.listmapid || office.listmapid.length === 0) {
        this.router.navigate([ROUTE_PATH.SETTINGS, ROUTE_PATH.TAGREGISTRATION]);
        return false;
    }
    this.router.navigate([ROUTE_PATH.MAP, office.listmapid.sort((a, b) => (a || "").localeCompare(b || ""))[0]]);
    return false;
  }
}
